module.exports = __webpack_public_path__ + "static/media/logo.998093dd.png";